import { ReactNode, useState } from 'react';
import FilterLines from '@untitled-ui/icons-react/build/esm/FilterLines';
import CloseIcon from '@untitled-ui/icons-react/build/esm/X';

import { Dropdown } from 'antd';

import './FilterChip.scss';

interface FilterChipProps {
  label: string;
  /** Controls for editing this filter, shown when the chip is clicked. */
  panel: ReactNode;
  onClear: () => void;
}

export const FilterChip = ({ label, panel, onClear }: FilterChipProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dropdown
      open={isOpen}
      onOpenChange={setIsOpen}
      trigger={['click']}
      placement="bottomLeft"
      overlayClassName="column-menu"
      dropdownRender={() => <>{panel}</>}
    >
      <div className="filter-chip" role="button" tabIndex={0}>
        <FilterLines className="h-3.5 w-3.5 shrink-0" />
        <span>{label}</span>

        <button
          type="button"
          aria-label={`Clear ${label} filter`}
          className="filter-chip-clear"
          onClick={(event) => {
            // Without this the chip's own click handler reopens the panel we just cleared.
            event.stopPropagation();
            onClear();
          }}
        >
          <CloseIcon className="h-3.5 w-3.5" />
        </button>
      </div>
    </Dropdown>
  );
};
